import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat',
})
export class PhoneFormatPipe implements PipeTransform {
  public transform(value: string | null | undefined, fallback = '-'): string {
    if (!value) {
      return fallback;
    }

    const phoneNumber = parsePhoneNumberFromString(value);

    return phoneNumber?.isValid() ? phoneNumber.formatInternational() : value;
  }
}
